import { render, staticRenderFns } from "./subTitle.vue?vue&type=template&id=4f9bed30&scoped=true"
import script from "./subTitle.vue?vue&type=script&lang=ts"
export * from "./subTitle.vue?vue&type=script&lang=ts"
import style0 from "./subTitle.vue?vue&type=style&index=0&id=4f9bed30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_idpt5aadqkxzu6szyh7dhosqta/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9bed30",
  null
  
)

export default component.exports